export const getImportJobs = (axiosPrivate) => {
  return axiosPrivate.get(`/master-data/import-tariff-jobs`)
}

export const retryImportJob = (axiosPrivate, id: string | number) => {
  return axiosPrivate.post(`/master-data/import-tariff-jobs/${id}/retry`)
}

export const cancelImportJob = (axiosPrivate, id: string | number) => {
  return axiosPrivate.post(`/master-data/import-tariff-jobs/${id}/cancel`)
}

export const revertImportJob = (axiosPrivate, id: string | number) => {
  return axiosPrivate.post(`/master-data/import-tariff-jobs/${id}/revert`)
}

export const revertComtradeJob = (axiosPrivate, id: string | number) => {
  return axiosPrivate.post(`/trade-data-management/comtrade-jobs/${id}/revert`)
}
